import React from 'react';

import { CallToActionCard } from 'src/components/call-to-action-card/CallToActionCard.view';
import { PaymentMethodsState } from 'src/redux-store/reducers/payment-methods';

import Button from 'Common/Button/Button';
import ButtonLink from 'src/components/common/ButtonLink/ButtonLink';
import { ExternalLink } from 'src/components/common/Links/ExternalLink';

import { Links } from 'src/constants/links';
import { usePaymentMethodCardsFactory } from './usePaymentMethodCardsFactory';
import { TestID } from 'src/testID';

import type { PaymentMethodCardProps } from 'src/types/common.types';
import type { PaymentMethodAPIPayload } from 'src/types/paymentMethod.types';

export const usePaymentMethodPageCardsFactory = (args: {
  paymentMethods: PaymentMethodsState;
  currentUserId: string;
  showRemoveConfirmation: (pm: PaymentMethodAPIPayload) => void;
  isPortalAdmin: boolean;
}) => {
  const { paymentMethods, currentUserId, showRemoveConfirmation, isPortalAdmin } = args;

  const paymentMethodCards: PaymentMethodCardProps[] = usePaymentMethodCardsFactory(
    paymentMethods,
    currentUserId,
    showRemoveConfirmation
  );

  const addPaymentMethodCard: PaymentMethodCardProps = {
    renderer: CallToActionCard,
    id: 'add-payment-method',
    name: 'Add payment method',
    tagline: 'Invoice only',
    description:
      'Currently we must validate your payment details manually, which might take a little time.',
    actions: [
      <ButtonLink key={crypto.randomUUID()} to="/user/payment-methods/create" size="small">
        Add…
      </ButtonLink>,
    ],
    testId: TestID.AddPaymentMethodCard,
  };

  const contactUsCard: PaymentMethodCardProps = {
    renderer: CallToActionCard,
    id: 'contact-us',
    name: 'Contact us',
    tagline: '',
    description: 'Interested in using Sesam Hub? Contact support@sesam.io for more information.',
    actions: [
      <ExternalLink
        href={Links.MailToSupportAtSesamDotIO}
        testId={TestID.ContactUsCardLinkButton}
        key={crypto.randomUUID()}
      >
        <Button theme="primary">Contact us...</Button>
      </ExternalLink>,
    ],
    testId: TestID.ContactUsCard,
  };

  return [...paymentMethodCards, isPortalAdmin ? addPaymentMethodCard : contactUsCard];
};
